/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are IUPAC ambiguity codes?`)
};

const es_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué son los códigos de ambigüedad IUPAC?`)
};

const de_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was sind IUPAC-Mehrdeutigkeitscodes?`)
};

const nl_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat zijn IUPAC-ambiguïteitscodes?`)
};

const fr_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que sont les codes d'ambiguïté IUPAC ?`)
};

const it_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa sono i codici di ambiguità IUPAC?`)
};

const pt_br2_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que são códigos de ambiguidade IUPAC?`)
};

const pt_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que são os códigos de ambiguidade IUPAC?`)
};

const ja_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IUPAC縮重コードとは何ですか？`)
};

const zh_iupac_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 IUPAC 简并码？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_q1", locale)
	if (locale === "en") return en_iupac_faq_q1(inputs)
	if (locale === "es") return es_iupac_faq_q1(inputs)
	if (locale === "de") return de_iupac_faq_q1(inputs)
	if (locale === "nl") return nl_iupac_faq_q1(inputs)
	if (locale === "fr") return fr_iupac_faq_q1(inputs)
	if (locale === "it") return it_iupac_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_q1(inputs)
	if (locale === "pt") return pt_iupac_faq_q1(inputs)
	if (locale === "ja") return ja_iupac_faq_q1(inputs)
	return zh_iupac_faq_q1(inputs)
};